var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"box is-flex is-pulled-left p-4"},[_c('figure',{staticClass:"image logo"},[_c('router-link',{attrs:{"to":_vm.getRoute}},[_c('img',{attrs:{"src":require("@/assets/logo-flood4cast.png")}})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }